import styled from "styled-components";
import { useSettingsStorageContext } from "./ContextLayer/SettingsStorageProvider";

const CheckBoxAtom = styled.div<{$darkMode: boolean}>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 23px;
    height: 20px;
    padding: 0px;
    margin: 0px;
    box-sizing: border-box;
    border: 2px solid ${props => props.$darkMode ? '#FEF7E2' : '#B58B77'};
    border-radius: 100px;
    cursor: pointer;
`

const CheckBoxCoreAtom = styled.div<{selected: boolean, $darkMode: boolean}>`
    width: 11px;
    height: 10px;
    padding: 0px;
    margin: 0px;
    box-sizing: border-box;
    background: ${props => props.selected ? props.$darkMode ? '#FEF7E2' : '#B58B77' : 'transparent'};
    border-radius: 100px;
`

type CheckBoxProps = {
    selected?: boolean
    onClick: () => void
}

export default function CheckBox({selected = false, onClick}: CheckBoxProps) {
    const { settings } = useSettingsStorageContext();
    return <CheckBoxAtom onClick={onClick} $darkMode={settings.darkMode}>
        <CheckBoxCoreAtom selected={selected} $darkMode={settings.darkMode}></CheckBoxCoreAtom>
    </CheckBoxAtom>
}